import { render, staticRenderFns } from "./t-orm-toolbar.vue?vue&type=template&id=1c7fde19&lang=pug"
import script from "./t-orm-toolbar.vue?vue&type=script&lang=js"
export * from "./t-orm-toolbar.vue?vue&type=script&lang=js"
import style0 from "./t-orm-toolbar.vue?vue&type=style&index=0&id=1c7fde19&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports